__webpack_require__.p = "/lt-language-program-quiz-2/";